/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { FileUploadDto } from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class UploadApi<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags Upload API
   * @name FileuploadControllerUploadFile
   * @summary 파일 업로드
   * @request POST:/api/upload
   */
  fileuploadControllerUploadFile = (data: FileUploadDto, params: RequestParams = {}) =>
    this.request<FileUploadDto, any>({
      path: `/api/upload`,
      method: 'POST',
      body: data,
      type: ContentType.FormData,
      format: 'json',
      ...params,
    });
}
